module.exports = __webpack_public_path__ + "img/new_logo.123af385.png";